import { useFairnessEnabled } from '../useFairnessEnabled';
import { useFairnessTicket } from '../useFairnessTicket';

export interface FairnessTicketKeeperProps {
  offerId: string | number | null | undefined;
}

/**
 * Pack page, headless: keeps the pack's ticket fresh while the page is on
 * screen, so "Learn More" opens with the hash already there and the purchase
 * never waits for a ticket. Nothing mounts for operators without provably
 * fair.
 */
export function FairnessTicketKeeper({ offerId }: FairnessTicketKeeperProps) {
  const enabled = useFairnessEnabled();
  if (!enabled) return null;
  return <Keeper offerId={offerId != null && offerId !== '' ? String(offerId) : null} />;
}

function Keeper({ offerId }: { offerId: string | null }) {
  useFairnessTicket(offerId);
  return null;
}
